
<div class="card py-10">

  <button routerLink="/auth/reset" ejs-button
    class="dl-button   mr-2 h-8 mb-5">
    <svg viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
      class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
    </svg>
  </button>

  <div class="w-full flex flex-col items-center justify-center">
    <div class="text-center w-5/6">
      <h2 class=" text-bold ">OTP</h2>
      <h5 class=" text-bold ">Inserisci il codice di 6 cifre inviato all'email</h5>
    </div>

    <div [formGroup]="formOtp" class="w-5/6 mt-4">

      <div class="relative mb-2 text-center ">
        <ejs-maskedtextbox #input class="otp-input transform duration-300" mask="000000"></ejs-maskedtextbox>
      </div>

      <div class="mt-5">
        <a (click)="resend()"
          class="text-sm font-light  cursor-pointer text-slate-400 hover:text-slate-800 transform duration-300">Non è arrivato
          nessun codice?</a>
          <ejs-message class="msg" severity="Warning" [visible]="wait" [content]="'Puoi richiedere un codice ogni 2 minuti'"></ejs-message>
          <ejs-message class="msg" severity="Success" [visible]="resent" [content]="'Il codice è stato inviato nuovamente'"></ejs-message>
      </div>
      
      <div class=" my-6">
        <button ejs-button class="e-primary transform duration-300"
          (click)="otpSubmit()">
          Continua
        </button>
      </div>

      <ejs-message class="msg w-full" severity="Error"
        [visible]="formHaveErrors" [content]="errMsg"></ejs-message>

      <ejs-message *ngIf="rispReset" class="msg w-full" severity="Error"
        [visible]="!rispReset.success"
        [content]="rispReset.error"></ejs-message>

      <!--   <div style="font-size: 10px;color:gray; padding-top:1em; width: 25em;">
          This site is protected by reCAPTCHA and the Google
          <a href="https://policies.google.com/privacy">Privacy Policy</a> and
          <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </div> -->
    </div>

  </div>
</div>